module.exports = __webpack_public_path__ + "static/img/hezuo.e480e52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hezuo.png
// module id = JjoH
// module chunks = 10